

[
    "identity/roles/list",
    "identity/users/list",
    "identity/companyaccessrestrictions/list",
    "identity/groups/list",
    "corepatterns/companies/list",
    "corepatterns/currencies/list",
    "corepatterns/countries/list",
    "corepatterns/regions/list",
    "corepatterns/postalzones/list",
    "corepatterns/units/list",
    "corepatterns/unitdimensions/list",
    "corepatterns/cultures/list",
    "corepatterns/sequences/list",
    "corepatterns/contacts/list",
    "corepatterns/contacttypes/list",
    "corepatterns/contactgroups/list",
    "corepatterns/fiscaltimezones/list",
    "corepatterns/importdatatemplates/list",
    "corepatterns/schemaentities/list",
    "corepatterns/assignments/list",
    "corepatterns/addresses/list",
    "corepatterns/backgroundoperations/list",
    "corepatterns/schemabusinessrules/list",
    "operations/notifications/list",
    "operations/emailtemplates/list",
    "businesscore/series/list",
    "businesscore/items/list",
    "businesscore/brands/list",
    "businesscore/assortments/list",
    "businesscore/exchangeratesdocuments/list",
    "businesscore/brandmodels/list",
    "businesscore/parties/list",
    "businesscore/personaldatareports/list",
    "taxescore/fiscaldocumenttypes/list",
    "taxescore/taxtypecodes/list",
    "taxescore/taxregionalareas/list",
    "taxescore/taxclasses/list",
    "taxescore/taxsubclasses/list",
    "taxescore/partytaxschemas/list",
    "taxescore/itemtaxschemas/list",
    "taxescore/fiscalclassifications/list",
    "taxescore/exemptionreasoncodes/list",
    "taxescore/economicactivityclassifications/list",
    "taxescore/taxessetups/list",
    "taxescore/withholdingtaxtypes/list",
    "taxescore/withholdingtaxcodes/list",
    "taxescore/partywithholdingtaxschemas/list",
    "taxescore/itemwithholdingtaxschemas/list",
    "taxescore/paymentmethodfiscalclassifications/list",
    "taxescore/fiscalwitholdingtaxtypes/list",
    "taxescore/authoritycommunicationrequests/list",
    "taxescore/openauthoritycommunicationrequests/list",
    "taxescore/listtaxpostings/list",
    "taxescore/listwtaxpostings/list",
    "taxescore/openwithholdingtaxes/list",
    "taxescore/taxessetupcvs/list",
    "taxescore/authoritycommunicationrequestcvs/list",
    "financialcore/paymentmethods/list",
    "financialcore/paymentterms/list",
    "financialcore/checks/list",
    "financialcore/paymenttypes/list",
    "financialcore/receipttypes/list",
    "financialcore/financialsetups/list",
    "financialcore/cashflowitems/list",
    "financialcore/voidreasons/list",
    "financialcore/outgoingchecklots/list",
    "financialcore/financialaccounts/list",
    "financialcore/purposes/list",
    "financialcore/dunningmethods/list",
    "financialcore/paymentcategorypurposes/list",
    "financialcore/bankaccounttypes/list",
    "financialcore/financialparties/list",
    "financialcore/financialinstitutions/list",
    "financialcore/accountpostings/list",
    "financialcore/agingreceivables/list",
    "financialcore/agingpayables/list",
    "financialcore/customerspendingentries/list",
    "financialcore/supplierspendingentries/list",
    "financialcore/customersstatements/list",
    "financialcore/suppliersstatements/list",
    "financialcore/accounts/list",
    "financialcore/accounttypes/list",
    "financialcore/accounttransactions/list",
    "financialcore/accountingsetups/list",
    "financialcore/accountbalances/list",
    "financialcore/partybankaccounts/list",
    "financialcore/monthlysalesperpartyitems/list",
    "financialcore/salesperpartyitems/list",
    "financialcore/financialaccountentries/list",
    "financialcore/financialaccountstatements/list",
    "financialcore/financialaccounttransfers/list",
    "financialcore/financialaccountbalances/list",
    "materialscore/itemsubtypes/list",
    "materialscore/materialssetups/list",
    "materialscore/warehouses/list",
    "materialscore/materialsitems/list",
    "materialscore/inventorypostings/list",
    "materialscore/stockfailures/list",
    "materialscore/stocksurplus/list",
    "materialscore/itemsstatements/list",
    "materialscore/stockmovements/list",
    "materialscore/stockondates/list",
    "salescore/pricelists/list",
    "salescore/salesitems/list",
    "salescore/customergroups/list",
    "salescore/customerparties/list",
    "salescore/salespersons/list",
    "salescore/saleschannels/list",
    "salescore/ordertypes/list",
    "salescore/quotationtypes/list",
    "salescore/invoicetypes/list",
    "salescore/memotypes/list",
    "salescore/salessetups/list",
    "salescore/stores/list",
    "salescore/posdevices/list",
    "logisticscore/deliveryterms/list",
    "logisticscore/memoreasons/list",
    "logisticscore/goodsreceiptnotetypes/list",
    "logisticscore/deliverytypes/list",
    "logisticscore/shippingmethods/list",
    "logisticscore/logisticssetups/list",
    "sales/orders/list",
    "sales/quotations/list",
    "sales/openquotations/list",
    "sales/openordersfordeliveries/list",
    "sales/openordersforinvoicings/list",
    "sales/ordersanalyses/list",
    "sales/returnordersanalyses/list",
    "purchasescore/suppliergroups/list",
    "purchasescore/purchasesitems/list",
    "purchasescore/invoicetypes/list",
    "purchasescore/memotypes/list",
    "purchasescore/ordertypes/list",
    "purchasescore/supplierparties/list",
    "purchasescore/purchasessetups/list",
    "purchases/orders/list",
    "shipping/deliveries/list",
    "shipping/shippingrequests/list",
    "shipping/openshippingrequests/list",
    "shipping/overdueshippingrequests/list",
    "billing/invoices/list",
    "billing/memos/list",
    "billing/billingrequests/list",
    "billing/openinvoicerequests/list",
    "billing/opencreditmemorequests/list",
    "billing/billingdocuments/list",
    "billing/yearlysalesanalyses/list",
    "billing/monthlysalesanalyses/list",
    "billing/salesanalysisperitems/list",
    "billing/salesdata/list",
    "billing/storedailysalesanalyses/list",
    "billing/storemonthlysalesanalyses/list",
    "billing/recurringinvoicetemplates/list",
    "billing/recurringinvoiceschedules/list",
    "goodsreceipt/goodsreceiptnotes/list",
    "goodsreceipt/goodsreceiptnotifications/list",
    "materialsmanagement/adjustmentreasons/list",
    "materialsmanagement/itemadjustments/list",
    "materialsmanagement/stocktransferorders/list",
    "bankaccounting/depositslips/list",
    "bankaccounting/financialaccountpostings/list",
    "bankaccounting/outgoingchecks/list",
    "bankaccounting/checkvoids/list",
    "bankaccounting/directdebitfiles/list",
    "bankaccounting/reconciliations/list",
    "cashmanagement/incomingchecks/list",
    "cashmanagement/incomingcashjournals/list",
    "cashmanagement/outgoingcashjournals/list",
    "taxes/legaldeclarations/list",
    "taxes/inventorydeclarations/list",
    "taxes/generatesafts/list",
    "taxes/legaldeclarationcvs/list",
    "invoicereceipt/invoices/list",
    "invoicereceipt/memos/list",
    "invoicereceipt/invoicereceiptnotifications/list",
    "invoicereceipt/invoicereceiptdocuments/list",
    "invoicereceipt/yearlypurchasesanalyses/list",
    "invoicereceipt/expenses/list",
    "accountspayable/payments/list",
    "accountspayable/eftorders/list",
    "accountsreceivable/receipts/list",
    "accountsreceivable/dunnings/list",
    "reporting/templates/list",
    "reporting/templateentitygroups/list"
]
